import * as moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  UncontrolledDropdown,
} from "reactstrap";
import { useRecoilState } from "recoil";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { popupCustomerFlowAtom, popupExchangeBetweenBankAccountAtom, popupTransactionHistoryAtom } from "../../state";
import banks from '../../utils/banks';
import { bankHoookTransactionColTable } from "../../utils/col-table";
import { MONEY_TYPE } from "../../utils/Utils";


const MONEY_TYPE_OPTIONS = Object.keys(MONEY_TYPE).map((c) => ({
  label: MONEY_TYPE[c],
  value: c,
}));

const BANK_OPTIONS = banks.map((c) => ({
  label: c.shortName,
  value: c.code,
  data: c,
}));


const BankHookTransactions = () => {
  const [dataTemp, setData] = useState([]);

  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [transferInternal, setTransferInternal] = useState({ IN: null, OUT: null });
  const [showTransferInternal, setShowTransferInternal] = useState(false);
  const [bankAccountOptions, setBankAccountOptions] = useState([]);
  const [popupCustomerFlow, setPopupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);
  const [popupTransactionHistory, setPopupTransactionHistory] = useRecoilState(popupTransactionHistoryAtom);
  const [popupExchangeBetweenBankAccount, setPopupExchangeBetweenBankAccount] = useRecoilState(popupExchangeBetweenBankAccountAtom);

  const [rangeDate, setRangeDate] = useState({
    startDate: moment(searchParams.get('startDate') || undefined).startOf('months').toDate(),
    endDate: moment(searchParams.get('endDate') || undefined).endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    type: searchParams.get('type') || undefined,
    bankCode: searchParams.get('bankCode') || undefined,
    bankNumber: searchParams.get('bankNumber') || undefined,
  });

  const data = useMemo(() => {
    return dataTemp.map(bankHookTransaction => {
      bankHookTransaction.bankAccount = bankAccountOptions.find(bankAccountOption => bankAccountOption?.data?.bankNumber === bankHookTransaction?.bankNumber)?.data;
      bankHookTransaction.lessAmount = (bankHookTransaction?.amount || 0) - (bankHookTransaction?.transactionHistoryTotal || 0)
      return bankHookTransaction;
    })
  }, [dataTemp, bankAccountOptions])
  const colTable = bankHoookTransactionColTable({
    actionCol: [
      ...(showTransferInternal ? [
        {
          Header: "Chuyển TK",
          accessor: (item) => <Input className="m-0 p-0" type="checkbox" checked={item.id === transferInternal[item.type]?.id} onClick={() => {
            setTransferInternal(transferInternal => ({
              ...transferInternal,
              [item.type]: item,
            }))
          }} />
        }
      ] : []),
      {
        Header: "Hành động",
        accessor: (item) => (
          <ul className="nk-tb-actions gx-1">
            <li>
              <UncontrolledDropdown>
                <DropdownToggle
                  tag="a"
                  className="btn btn-icon dropdown-toggle btn-trigger"
                >
                  <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                  <ul className="link-list-opt no-bdr">
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#edit"
                        onClick={(ev) => {
                          ev.preventDefault();
                          history.push(`/bank-hook-transactions/${item.id}`);
                        }}
                      >
                        <Icon
                          name={"money"}
                        ></Icon>
                        <span>
                          Quản lý giao dịch nội bộ
                        </span>
                      </DropdownItem>
                    </li>
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#edit"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setPopupTransactionHistory({
                            show: true,
                            data: {
                              id: '',
                              type: item.type,
                              defaultValue: {
                                hookTransactionHistoryId: item.id,
                                content: item.content,
                                amount: item.lessAmount,
                                date: moment(item.createdAt).format('YYYY-MM-DD'),
                                ...(item.bankAccount ? {
                                  bankAccountId: item.bankAccount.id,
                                } : {})
                              }
                            }
                          })
                        }}
                      >
                        <Icon
                          name={"money"}
                        ></Icon>
                        <span>
                          Thêm {MONEY_TYPE[item.type]}
                        </span>
                      </DropdownItem>
                    </li>
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#edit"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setPopupCustomerFlow({
                            show: true,
                            data: {
                              id: '',
                              type: item.type,
                              defaultValue: {
                                hookTransactionHistoryId: item.id,
                                content: item.content,
                                amount: item.lessAmount,
                                date: moment(item.createdAt).format('YYYY-MM-DD'),
                                ...(item.bankAccount ? {
                                  bankAccountId: item.bankAccount.id,
                                } : {})
                              }
                            }
                          })
                        }}
                      >
                        <Icon
                          name={"money"}
                        ></Icon>
                        <span>
                          Thêm {MONEY_TYPE[item.type]} NCC/KH
                        </span>
                      </DropdownItem>
                    </li>

                    <li>
                      <DropdownItem
                        tag="a"
                        href="#edit"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setPopupExchangeBetweenBankAccount({
                            ...popupExchangeBetweenBankAccount,
                            show: true,
                            data: {
                              id: 'add',
                              defaultValue: {
                                date: moment(item.createdAt).format('YYYY-MM-DD'),
                                content: item.content,
                                amount: item.amount,
                                [item.type === 'IN' ? 'hookInTransactionHistoryId' : 'hookOutTransactionHistoryId']: item.id,
                                ...(item.bankAccount ? {
                                  [item.type === 'IN' ? 'toBankAccountId' : 'fromBankAccountId']: item.bankAccount.id
                                } : {})
                              }

                            },
                          })
                        }}
                      >
                        <Icon
                          name={"money"}
                        ></Icon>
                        <span>
                          Chuyển TK Khác
                        </span>
                      </DropdownItem>
                    </li>


                  </ul>
                </DropdownMenu>
              </UncontrolledDropdown>
            </li>
          </ul>
        ),
      }
    ]
  })
  useEffect(() => {
    GET(`bank-account`, {}, true).then((resp) => {
      setBankAccountOptions(
        resp.data.filter(e => !!e.bankNumber).map((c) => ({
          label: `${c.name}`,
          value: c.bankNumber,
          data: c,
        }))
      );
    });
  }, []);


  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.bankCode ? { bankCode: filter.bankCode } : {}),
      ...(filter.bankNumber ? { bankNumber: filter.bankNumber } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    getData();
  }, [timeNow, filter, popupCustomerFlow?.updatedAt, popupTransactionHistory?.updatedAt, popupExchangeBetweenBankAccount?.updatedAt]);

  const getData = () => {
    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.bankCode ? { bankCode: filter.bankCode } : {}),
      ...(filter.bankNumber ? { bankNumber: filter.bankNumber } : {}),
    };

    GET(`/hook-transaction-history`, params, true)
      .then(({ data }) => {
        setData([...data.rows]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  return (
    <React.Fragment>
      <Head title="Quản lý giao dịch nội bộ"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Quản lý giao dịch nội bộ</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap mw-200px">
                        <RSelect
                          placeholder={'Lọc theo TK'}
                          isClearable
                          options={bankAccountOptions}
                          value={bankAccountOptions.find((c) => c.value === filter.bankNumber)}
                          onChange={(val) => setFilter({
                            ...filter,
                            bankNumber: val?.value || undefined
                          })}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap mw-200px">
                        <RSelect
                          placeholder={'Lọc theo NH'}
                          isClearable
                          options={BANK_OPTIONS}
                          value={BANK_OPTIONS.find((c) => c.value === filter.bankCode)}
                          onChange={(val) => setFilter({
                            ...filter,
                            bankCode: val?.value || undefined
                          })}
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          classNamePrefix="form-control"
                          isClearable
                          placeholder="Lọc loại tiền"
                          options={MONEY_TYPE_OPTIONS}
                          value={MONEY_TYPE_OPTIONS.find(
                            (c) => c.value === filter.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                      >

                        <Button className={'ml-2 btn-secondary'} onClick={() => {
                          setShowTransferInternal((showTransferInternal) => !showTransferInternal)
                          setTransferInternal({
                            IN: null,
                            OUT: null
                          })
                        }}>{showTransferInternal ? 'Ẩn chuyển TK khác' : 'Chuyển TK Khác'}</Button>
                      </div>
                    </li>
                    {
                      showTransferInternal && <li>
                        <div
                          className="form-control-wrap"
                        >
                          <Button
                            disabled={!transferInternal.IN || !transferInternal.OUT}
                            className={'ml-2  btn-primary'} onClick={() => {
                              if (transferInternal.IN.amount !== transferInternal.OUT.amount) {
                                toast.error('Vui lòng chọn giao dịch có số tiền trùng khớp')
                                return;
                              }
                              setPopupExchangeBetweenBankAccount({
                                ...popupExchangeBetweenBankAccount,
                                show: true,
                                data: {
                                  id: 'add',
                                  defaultValue: {
                                    hookInTransactionHistoryId: transferInternal.IN.id,
                                    hookOutTransactionHistoryId: transferInternal.OUT.id,
                                    date: moment(transferInternal.IN.createdAt).format('YYYY-MM-DD'),
                                    content: transferInternal.IN.content,
                                    amount: transferInternal.IN.amount,
                                    ...(transferInternal.OUT.bankAccount ? {
                                      fromBankAccountId: transferInternal.OUT.bankAccount.id,
                                    } : {}),
                                    ...(transferInternal.IN.bankAccount ? {
                                      toBankAccountId: transferInternal.IN.bankAccount.id,
                                    } : {}),

                                  }

                                },
                              })
                              setTransferInternal({
                                OUT: null,
                                IN: null
                              })
                            }}>Thực hiện chuyển TK Khác</Button>
                        </div>
                      </li>
                    }

                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    notShowPagi
                    loading={loading}
                    columns={colTable}
                    data={data}
                    conditionHighlightRow={(item) => item.amount !== item.transactionHistoryTotal ? 'font-weight-bold text-danger' : ''}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default BankHookTransactions;
